import { Facebook, Image as ImageIcon, Instagram } from "lucide-react";
import { Logo, LogoFull } from "./Logo";
import { scrollToId } from "./smooth";
import { useT } from "../../lib/content";

const NAV = [["galerie", "Galerie"], ["apropos", "L'artiste"], ["coeurs", null], ["contact", "Contact"]];

export const Footer = () => {
  const t = useT();
  return (
  <footer className="bg-[#0F1820] text-[#F6F1E9] pt-20 pb-10 overflow-hidden" data-testid="footer-container">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5" data-testid="footer-monogram">
          <Logo light size="lg" testid="footer-logo-link" onClick={(e) => { e.preventDefault(); scrollToId("top"); }} />
          <p className="mt-6 text-slate-300 max-w-sm font-light">{t("footer_text")}</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={t("instagram_url")} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"
              className="inline-flex items-center gap-2 border border-white/25 px-4 py-2 rounded-full text-sm hover:bg-white/10 transition-colors"><Instagram className="w-4 h-4" />Instagram</a>
            <a href={t("facebook_url")} target="_blank" rel="noopener noreferrer" data-testid="about-facebook-link"
              className="inline-flex items-center gap-2 border border-white/25 px-4 py-2 rounded-full text-sm hover:bg-white/10 transition-colors"><Facebook className="w-4 h-4" />Facebook</a>
            <a href={t("gallea_url")} target="_blank" rel="noopener noreferrer" data-testid="footer-gallea-link"
              className="inline-flex items-center gap-2 border border-white/25 px-4 py-2 rounded-full text-sm hover:bg-white/10 transition-colors"><ImageIcon className="w-4 h-4" />Gallea</a>
          </div>
        </div>
        <div className="md:col-span-3">
          <h4 className="text-[11px] tracking-[0.3em] uppercase text-[#E0C48C] mb-4">Navigation</h4>
          <ul className="grid gap-2 text-slate-200">
            {NAV.map(([id, l]) => <li key={id}><a href={`#${id}`} onClick={(e) => { e.preventDefault(); scrollToId(id); }} data-testid={`footer-${id}-link`} className="nav-link">{l ?? t("nav_hearts")}</a></li>)}
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="text-[11px] tracking-[0.3em] uppercase text-[#E0C48C] mb-4">Achats</h4>
          <ul className="grid gap-2 text-slate-200 font-light">
            <li>{t("footer_buy1")}</li><li>{t("footer_buy2")}</li><li>{t("footer_buy3")}</li>
          </ul>
        </div>
      </div>
      <div className="mt-10 text-white/[0.06] select-none" aria-hidden="true"><LogoFull className="w-full max-w-[900px] h-auto" /></div>
      <div className="pt-6 border-t border-white/10 flex flex-wrap justify-between gap-3 text-xs text-slate-400">
        <span data-testid="footer-copyright">{t("copyright")}</span>
        <a href="/admin" className="hover:text-slate-200" data-testid="nav-admin-link">Espace artiste</a>
      </div>
    </div>
  </footer>
  );
};
